export default __webpack_public_path__ + "81c4fae7cdf49477c78570ad842a51df.png";